import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    Grid,
    TextField,
    Typography,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import baseURL from "../../config"; // adjust if needed
import { useParams, useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

const CrewingAgentExecutive = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phoneNumber: "",
        password: "",
        confirmPassword: "",
    });


    const [crewingAgent, setCrewingAgent] = useState(null);
    const [loading, setLoading] = useState(false)


    useEffect(() => {
        const fetchCrewingAgent = async () => {
            try {
                const res = await axios.get(
                    `${baseURL}/api/getCrewingAgentsDetailsById/${id}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                        },
                    }
                );

                setCrewingAgent(res.data); // store agent details
                console.log("Crewing Agent Details:", res.data);
            } catch (err) {
                console.error("Error fetching crewing agent:", err);
                toast.error("❌ Failed to fetch agent details");
            }
        };

        fetchCrewingAgent();
    }, []);

    // handle input change
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    // handle form submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (
            !formData.name ||
            !formData.email ||
            !formData.phoneNumber ||
            !formData.password ||
            !formData.confirmPassword
        ) {
            toast.error("⚠️ Please fill all fields");
            return;
        }

        if (formData.password !== formData.confirmPassword) {
            toast.error("❌ Passwords do not match!");
            return;
        }

        try {
            const res = await axios.post(
                `${baseURL}/api/crewingAgentExecutive`,
                {
                    name: formData?.name,
                    email: formData?.email,
                    phoneNumber: formData?.phoneNumber,
                    password: formData?.password,
                    crewingAgentId: crewingAgent?._id,
                    crewingAgentName: crewingAgent?.agentName,
                }
            );
            localStorage.setItem("userEmail", formData?.email);
            toast.success("✅ Executive added successfully!");
            console.log("API Response:", res.data);
            setLoading(false);


            // reset form after success
            setFormData({
                name: "",
                email: "",
                phoneNumber: "",
                password: "",
                confirmPassword: "",
            });

            setTimeout(() => {
                navigate("/otp");
            }, 1500);
        } catch (err) {
            console.error("API Error:", err);
            toast.error(
                err.response?.data?.message || "❌ Failed to add executive"
            );
        }
    };

    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "linear-gradient(135deg, #fceabb, #f8b500)",
                    overflow: "hidden",
                    p: 2,
                }}
            >
                <Card
                    sx={{
                        width: "100%",
                        maxWidth: 500,
                        borderRadius: 5,
                        boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                        backdropFilter: "blur(10px)",
                        background: "rgba(255, 255, 255, 0.95)",
                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        "&:hover": {
                            transform: "translateY(-5px)",
                            boxShadow: "0 12px 28px rgba(0,0,0,0.3)",
                        },
                    }}
                >
                    <CardContent>
                        <Typography
                            variant="h4"
                            sx={{
                                mb: 2,
                                fontWeight: "bold",
                                textAlign: "center",
                                color: "#a50a10",
                            }}
                        >
                            Add Executive
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{ mb: 4, textAlign: "center", color: "text.secondary" }}
                        >
                            Please fill the details below to create a new executive account.
                        </Typography>

                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Full Name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        variant="outlined"
                                        required
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "12px",
                                            },
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Email Address"
                                        name="email"
                                        type="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        variant="outlined"
                                        required
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "12px",
                                            },
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        fullWidth
                                        label="Phone Number"
                                        name="phoneNumber"
                                        type="tel"
                                        value={formData.phoneNumber}
                                        onChange={handleChange}
                                        variant="outlined"
                                        required
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "12px",
                                            },
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Password"
                                        name="password"
                                        type="password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        variant="outlined"
                                        required
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "12px",
                                            },
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="Confirm Password"
                                        name="confirmPassword"
                                        type="password"
                                        value={formData.confirmPassword}
                                        onChange={handleChange}
                                        variant="outlined"
                                        required
                                        sx={{
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "12px",
                                            },
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                                    {loading ? (
                                        <CircularProgress sx={{ color: "#C30B12", mt: 2 }} />
                                    ) : (
                                        <Button
                                            type="submit"
                                            fullWidth
                                            sx={{
                                                mt: 2,
                                                py: 1.5,
                                                borderRadius: "50px",
                                                fontWeight: "bold",
                                                fontSize: "16px",
                                                textTransform: "none",
                                                background:
                                                    "linear-gradient(90deg, #C30B12, #a50a10, #C30B12)",
                                                color: "white",
                                                boxShadow: "0 4px 14px rgba(0,0,0,0.3)",
                                                "&:hover": {
                                                    background:
                                                        "linear-gradient(90deg, #a50a10, #C30B12, #a50a10)",
                                                    boxShadow: "0 6px 18px rgba(0,0,0,0.4)",
                                                },
                                            }}
                                        >
                                            Save Executive
                                        </Button>
                                    )}
                                </Grid>
                            </Grid>
                        </form>
                    </CardContent>
                </Card>
            </Box>
            <ToastContainer position="top-right" autoClose={3000} theme="colored" />
        </>
    );
};

export default CrewingAgentExecutive;
